import { Backbone, Radio, _ } from "../../vendor";

import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Location from "../models/Location";

/**
 * In special cases, such as OrdersView, we also want to access already
 * deleted items (locations). This is what this file does.
 * this refs #20061
 */

export default InboomaBaseAsyncCollection.extend({
  collectionName: "locationsWithTrashed",
  model: Location,
  url: "/locations/getTrashed?find=short",

  /**
   * @return {Array} deleted and regular location models
   */
  getAllLocations() {
    const models = _.clone(this.models);

    if (typeof Radio._channels["locations"] !== "undefined") {
      _.each(Radio.channel("locations").request("get:data").models, (location) => {
        models.push(location);
      });
    }

    return models;
  },

  /**
   * @override Backbone.Collection.get
   *
   * @param {Number} id
   * @return {Backbone.Model||undefined}
   */
  get(id) {
    if (typeof id === "object") return false;

    let result = Backbone.Collection.prototype.get.call(this, id);

    if (
      typeof result === "undefined" &&
      typeof Radio._channels["locations"] !== "undefined" &&
      typeof Radio._channels["locations"]["_requests"] !== "undefined"
    ) {
      const locations = Radio.channel("locations").request("get:data");
      result = locations.get(id);
    }

    return result;
  },
});
